/*
 * jBone.widget.accordion
 *
 * You should define in your hmtl next structure with classes:
 *
 * .fn-accordion           to this element widget will add/remove class "expanded"
 * .fn-accordion-target    only by clicking on this element widget will add/remove class "expanded"
 * .fn-accordion-body      content inside will be "expanded" after click on accordion widget
 *
 * @param isCollapseSiblings defines whether or not content inside sibling accordion widgets should be hidden after expending
 * targeted accordion widget (basically, means, that only one widget can be expanded at a time)
 * // template.html
 * <div class="fn-accordion">
 *     <div class="fn-accordion-target">title text</div>
 *     <div class="fn-accordion-body">some content</div>
 * </div>
 *
 * // view.js
 * this.attachWidget(this.$el.accordion());
 *
 *
 */

define(function(require) {
    var $ = require('j');

    require('common/jbone.widget');
    require('widgets/accordion.widget');

    return $.widget('accordion', 'accordion', {

        _classChangeOperator: function(item, header, body, action) {
            var changeClassFunction = function(className) {
                this && this.classList && this.classList[action](className);
            };

            var getExpandedState = function(el) {
                return el && el.classList && el.classList.contains('opened');
            };

            var isExpandedBefore = getExpandedState(item);

            this.options.expandedClass
            && this.options.expandedClass.split(' ').forEach(changeClassFunction, item);
            this.options.headerExpandedClass
            && this.options.headerExpandedClass.split(' ').forEach(changeClassFunction, header);
            this.options.bodyExpandedClass
            && this.options.bodyExpandedClass.split(' ').forEach(changeClassFunction, body);

            var isExpandedAfter = getExpandedState(item);
            var hasChanged = isExpandedBefore ^ isExpandedAfter;
            hasChanged && this._triggerExpandCollapseEvent(item, isExpandedAfter);
        }
    });
});
